import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ImportService } from '../../../services/import.service';
import { PartnerService } from '../../../services/partner.service';
import { MatDialog } from '@angular/material/dialog';
import { ApproveProsModalComponent } from '../../_modals/approve-pros-modal/approve-pros-modal.component';
import { ExportProModalComponent } from '../../_modals/export-pro-modal/export-pro-modal.component';
import { ProDataFilterModalComponent } from '../../_modals/pro-data-filter-modal/pro-data-filter-modal.component';
import { SliderDialogService } from 'src/app/shared/services/slider-dialog.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-partner-detail-pro-header',
  templateUrl: './partner-detail-pro-header.component.html',
  styleUrls: ['./partner-detail-pro-header.component.scss']
})
export class PartnerDetailProHeaderComponent implements OnInit {
  @Input() importExists;

  @Output() headerChangeEvent = new EventEmitter<any>();
  @Output() getProsClicked = new EventEmitter<void>();

  proTypes = [];
  proYears = [];
  proQuarters = [];

  proType: string;
  proYear: number;
  proQuarter: string;

  proStatus = '';
  partnerId;
  filterCategories;

  constructor(private importService: ImportService, private partnerService: PartnerService, public dialog: MatDialog, private sliderDialogService: SliderDialogService,
              private router: Router) {
    this.proTypes = this.importService.importTypes;

    //default to first option in list
    this.proType = this.proTypes[0];
    this.setProType();

    this.proYears = this.importService.importYears;

    //default to first option in list
    this.proYear = this.proYears[0];
    this.setProYear();
    
    this.proQuarters = this.importService.importQuarters;

    //default to first option in list
    this.proQuarter = this.proQuarters[0];
    this.setProQuarter();

    //track selected pro data status
    this.partnerService.proStatus$.subscribe((x) => {
      this.proStatus = x;
    })
   }

  ngOnInit() {
    this.proTypes = this.importService.importTypes;

    //default to first option in list
    this.proType = this.proTypes[0];
    this.setProType();

    this.proYears = this.importService.importYears;

    //default to first option in list
    this.proYear = this.proYears[0];
    this.setProYear();
    
    this.proQuarters = this.importService.importQuarters;

    //default to first option in list
    this.proQuarter = this.proQuarters[0];
    this.setProQuarter();

    //track selected pro data status
    this.partnerService.proStatus$.subscribe((x) => {
      this.proStatus = x;
    })

    this.partnerId = this.partnerService.selectedPartnerId;

  }


  setProType() {
    this.partnerService.setProType(this.proType);
    this.headerChangeEvent.emit(this.proType);
  }

  setProYear() {
    this.partnerService.setProYear(this.proYear);
    this.headerChangeEvent.emit(this.proYear);
  }

  setProQuarter() {
    this.partnerService.setProQuarter(this.proQuarter);
    this.headerChangeEvent.emit(this.proQuarter);
  }


  approvePro(){
    const dialogRef = this.dialog.open(ApproveProsModalComponent, {
      // width: '800px',
      // height: '400px',
      // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      
      // this.partnerService.getPartnerGroups().subscribe((x) => {
      //   this.partnerService.setPartnerGroups(x);
      // });

    });
  }

  exportPro(){
    const dialogRef = this.dialog.open(ExportProModalComponent, {
      data: {
        pro: {
          type: this.proType,
          quarter: this.proQuarter,
          year: this.proYear,
        },
        pros: [{
          type: this.proType,
          quarter: this.proQuarter,
          year: this.proYear,
          pdfSelected: false,
          csvSelected: false,
          xlsxSelected: false
        }],
        // pros: [],
        partnerId: this.partnerId,
        filterCategories: this.filterCategories
      }
      // width: '800px',
      // height: '400px',
      // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      
      // this.partnerService.getPartnerGroups().subscribe((x) => {
      //   this.partnerService.setPartnerGroups(x);
      // });

    });
  }

  showFilterPanel(){
    this.sliderDialogService.close(true);
    this.sliderDialogService.open(ProDataFilterModalComponent, {
      width: "600px",
      title: "FILTERS",
      panelClass: "edit-track-dialog",
      data: {  }
    }, (user) => {

    });
  }

  /**
   * For step 1 - shows the pro-import view
   */
  openProImport() {
    var variablesSet = this.importService.areAllImportVariablesSet();

    if(variablesSet){
      //navigate to import view
      this.router.navigate(['data/pro/import'])
    }
  }

  onGetProsClick() {
    this.partnerService.setHasClickedGetPros(true);
    this.getProsClicked.emit();
  }

}
